module.exports = __webpack_public_path__ + "static/media/opening_altia.2fdf751d.jpg";